module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.currentProject) ? _c('div', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "page-select col-md-3"
  }, [_c('b-form-select', {
    attrs: {
      "options": _vm.viewOptions
    },
    model: {
      value: (_vm.currentView),
      callback: function($$v) {
        _vm.currentView = $$v
      },
      expression: "currentView"
    }
  })], 1)]), _vm._v(" "), (_vm.currentView == 'baseline-explorer') ? _c('baseline-explorer') : _vm._e(), _vm._v(" "), (_vm.currentView == 'baseline-comparison') ? _c('baseline-comparison') : _vm._e()], 1) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-fd43c184"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/BaselineView.vue
// module id = 1031
// module chunks = 1